
export const exclusion_string = (toddlers_allowed, pregnant_allowed) => {
    let str = 'Unable to accommodate ';
    if (pregnant_allowed == 2) {
        str += ' <strong>anyone over 26 weeks of pregnancy</strong> and';
    }
    else if (pregnant_allowed == 0) {
        str += ' <strong>anyone pregnant</strong> and';
    }
   
    if (toddlers_allowed == 0) {
        str += ' <strong>children under 6</strong>';
    }
    else {
        str += ' <strong>children under 3</strong>';
    }
    return str + '.';
}

export const setup_ajax_triggers = () => {
    $(document).ajaxComplete(function( event, jqxhr, settings, exception ) {
        if ( jqxhr.status == 503 && jqxhr.responseJSON && jqxhr.responseJSON.errors && jqxhr.responseJSON.meta.error_code && jqxhr.responseJSON.meta.error_code == 5000) {
            $(document).trigger('bw-maintenance-error', {error: jqxhr.responseJSON.errors.join(' '), jqxhr:jqxhr});
        }
        $(document).trigger('bw-server-error', {error: 'A ' + jqxhr.status + ' error has occcured', jqxhr:jqxhr});
    });
}